export default "__VITE_ASSET__DOj7SCQc__"